import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

/**
 * Barra contextual de la selección con checkbox (misma idea que en los
 * catálogos): cuántos hay seleccionados, exportarlos a Excel y cancelar.
 * Se muestra solo si `count > 0`.
 */
@Component({
  selector: 'app-selection-bar',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatTooltipModule],
  template: `@if (count > 0) {
<div class="selection-bar">
  <div class="selection-bar__info"><mat-icon>check_circle</mat-icon><span><b>{{ count }}</b> {{ count === 1 ? 'seleccionado' : 'seleccionados' }}</span></div>
  <div class="selection-bar__actions">
    <ng-content></ng-content>
    <button mat-stroked-button type="button" matTooltip="Exportar la selección a Excel" (click)="export.emit()"><mat-icon>file_download</mat-icon> Exportar</button>
    <button mat-icon-button type="button" matTooltip="Cancelar selección" (click)="clear.emit()"><mat-icon>close</mat-icon></button>
  </div>
</div>
}`,
  styles: [`
    .selection-bar {
      display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;
      margin: 0 20px 10px; padding: 8px 12px 8px 16px;
      background: #eef0fd; border: 1px solid #c9ccf5; border-radius: 14px; color: #170f5f;
    }
    .selection-bar__info { display: flex; align-items: center; gap: 8px; }
    .selection-bar__info mat-icon { color: #1010eb; }
    .selection-bar__actions { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
    .selection-bar__actions button[mat-stroked-button] { border-radius: 18px; }
  `],
})
export class SelectionBarComponent {
  @Input() count = 0;
  @Output() export = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();
}
